import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from "../../Header/header";
import ASSidebar from "../../Dashboard/SuperAdmin/Superadmincom/SuperAdminSidebar";
import { API_LoginURL } from '../../../config';
export default function RoleMaster() {
  const [roles, setRoles] = useState([]); // State to store the roles
  const [loading, setLoading] = useState(true); // State to manage the loading state
  const fetchRoles = async () => {
    console.log(localStorage.getItem("token"),"token")
  try {
    const response = await axios.get(API_LoginURL + "Role/RoleList", {
        headers: {
        "Content-Type":'accept: text/plain',
        Authorization: localStorage.getItem("token"), // Add token to Authorization header
        },
      }); // Replace with your API endpoint
    setRoles(response.data); // Set the roles data to state
    setLoading(false); // Stop loading after data is fetched
  } catch (error) {
    console.error('Error fetching roles:', error);
    setLoading(false); // Stop loading even if an error occurs
  }
};
useEffect(() => {
    fetchRoles();
  }, []); // Empty dependency array to run the effect only once when the component mounts

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <ASSidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Roll Master</h4>
                  <div className="table-responsive">
                    {loading ? (
                      <div className="loader">Loading...</div> // Show a loader while data is being fetched
                    ) : (
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th> ID </th>
                            <th> Roll </th>
                          </tr>
                        </thead>
                        <tbody>
                          {roles.map((role) => (
                            <tr key={role.id}> {/* Map through the roles and display them */}
                              <td className="py-1">{role.roleId}</td>
                              <td>{role.roleName}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
